/* eslint-disable no-fallthrough */
import { FromString } from './html';
import { GetIconLibrary } from './icons';

export function Issuer(cc: string): string {
    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // regexp string length {0} provided for soonest detection of beginning of the card numbers this way it could be used for BIN CODE detection also

    // JCB
    const jcb = new RegExp('^(?:2131|1800|35)[0-9]{0,}$'); // 2131, 1800, 35 (3528-3589)
    // American Express
    const amex = new RegExp('^3[47][0-9]{0,}$'); // 34, 37
    // Diners Club
    const diners = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$'); // 300-305, 309, 36, 38-39
    // Visa
    const visa = new RegExp('^4[0-9]{0,}$'); // 4
    // MasterCard
    const mastercard = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$'); // 2221-2720, 51-55
    const maestro = new RegExp('^(5[06789]|6)[0-9]{0,}$'); // always growing in the range: 60-69, started with / not something else, but starting 5 must be encoded as mastercard anyway
    // Discover
    const discover = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');
    //// 6011, 622126-622925, 644-649, 65

    // get rid of anything but numbers
    const curVal = cc.replace(/\D/g, '');

    // checks per each, as their could be multiple hits
    // fix: ordering matter in detection, otherwise can give false results in rare cases
    let selBrand: string = '';
    if (jcb.exec(curVal)) {
        selBrand = 'JCB';
    } else if (amex.exec(curVal)) {
        selBrand = 'Amex';
    } else if (diners.exec(curVal)) {
        selBrand = 'Diners Club';
    } else if (visa.exec(curVal)) {
        selBrand = 'Visa';
    } else if (mastercard.exec(curVal)) {
        selBrand = 'Mastercard';
    } else if (discover.exec(curVal)) {
        selBrand = 'Discover';
    } else if (maestro.exec(curVal)) {
        if (curVal.startsWith('5')) { // started 5 must be mastercard
            selBrand = 'Mastercard';
        } else {
            selBrand = 'Maestro'; // maestro is all 60-69 which is not something else, thats why this condition in the end
        }
    }

    return selBrand;
}

export function IssuerIcon(cc: string): HTMLElement {
    switch (Issuer(cc)) {
    case 'JCB':
        switch (GetIconLibrary()) {
        case 'fontAwesome4':
            return FromString('<i class="fa fa-cc-jcb"></i>');
        case 'fontAwesome5':
            return FromString('<i class="fab fa-cc-jcb"></i>');
        case 'materialSymbolsRounded':
            return FromString('<span class="material-icons-rounded">credit_card</span>');
        }
    case 'Amex':
        switch (GetIconLibrary()) {
        case 'fontAwesome4':
            return FromString('<i class="fa fa-cc-amex"></i>');
        case 'fontAwesome5':
            return FromString('<i class="fab fa-cc-amex"></i>');
        case 'materialSymbolsRounded':
            return FromString('<span class="material-icons-rounded">credit_card</span>');
        }
    case 'Diners Club':
        switch (GetIconLibrary()) {
        case 'fontAwesome4':
            return FromString('<i class="fa fa-cc-diners-club"></i>');
        case 'fontAwesome5':
            return FromString('<i class="fab fa-cc-diners-club"></i>');
        case 'materialSymbolsRounded':
            return FromString('<span class="material-icons-rounded">credit_card</span>');
        }
    case 'Visa':
        switch (GetIconLibrary()) {
        case 'fontAwesome4':
            return FromString('<i class="fa fa-cc-visa"></i>');
        case 'fontAwesome5':
            return FromString('<i class="fab fa-cc-visa"></i>');
        case 'materialSymbolsRounded':
            return FromString('<span class="material-icons-rounded">credit_card</span>');
        }
    case 'Mastercard':
        switch (GetIconLibrary()) {
        case 'fontAwesome4':
            return FromString('<i class="fa fa-cc-mastercard"></i>');
        case 'fontAwesome5':
            return FromString('<i class="fab fa-cc-mastercard"></i>');
        case 'materialSymbolsRounded':
            return FromString('<span class="material-icons-rounded">credit_card</span>');
        }
    case 'Discover':
        switch (GetIconLibrary()) {
        case 'fontAwesome4':
            return FromString('<i class="fa fa-cc-discover"></i>');
        case 'fontAwesome5':
            return FromString('<i class="fab fa-cc-discover"></i>');
        case 'materialSymbolsRounded':
            return FromString('<span class="material-icons-rounded">credit_card</span>');
        }
    default:
        throw new Error('unknown credit card issuer');
    }
}